import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
} from '@angular/core';
import { CardComponent } from '../card/card.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'hd-dialog',
  standalone: true,
  imports: [CardComponent, TranslateModule],
  templateUrl: './dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './dialog.component.scss',
})
export class DialogComponent {
  @Input({ required: true }) dialogTitle!: string;
  @Input({ required: true }) closeRequested!: EventEmitter<void>;
  @Input() customLayout?: boolean;
}
